/* eslint-disable import/no-anonymous-default-export */
import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const endpoint_one = process.env.REACT_APP_API_ENDPOINT_ONE;
const api_version = process.env.REACT_APP_API_VERSION;

export default {
  getHostels: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Hostel/GetHostels?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getHostelFloors: (token, schoolId, hostelId) => {
    let url = `${endpoint_two}/api/v${api_version}/Hostel/GetHostelFloors?schoolId=${schoolId}`;
    if (hostelId !== undefined && hostelId !== null) {
      url += `&hostelId=${hostelId}`;
    }
    return axiosClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  getRooms: (token, schoolId, hostelId, floorId) => {
    let url = `${endpoint_two}/api/v${api_version}/Hostel/GetRooms?schoolId=${schoolId}`;
    if (floorId !== undefined && floorId !== null) {
      url += `&floorId=${floorId}`;
    }
    if (hostelId !== undefined && hostelId !== null) {
      url += `&hostelId=${hostelId}`;
    }
    return axiosClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  getBeds: (token, schoolId, hostelId, roomId) => {
    let url = `${endpoint_two}/api/v${api_version}/Hostel/GetBeds?schoolId=${schoolId}`;
    if (hostelId !== undefined && hostelId !== null) {
      url += `&hostelId=${hostelId}`;
    }
    if (roomId !== undefined && roomId !== null) {
      url += `&roomId=${roomId}`;
    }
    return axiosClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  allocateHostel: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Hostel/update-student-hostel-allocation`,
        data,
        {
          headers: {
            Authorization: `Bearer  ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  getManagers: (token) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/Hostel/GetManagers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  getOccupants: (token, hostelId, floorId, roomId, sessionId, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Hostel/GetHostelOccupants?hostelId=${hostelId}&floorId=${floorId}&roomId=${roomId}&sessionId=${sessionId}&schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  createHouse: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/Hostel/CreateHostel`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  EditHouse: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/Hostel/UpdateHostel`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
   getHouses: (token, schoolId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/Hostel/houses/${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addHouse: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/Hostel/create-house`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  EditCreatedHouse: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/Hostel/update-house`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteHouse: (token, id) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/Hostel/delete-house?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  // New endpoints for house allocation
  getClasses: (token) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/Hostel/classes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  getStudents: (token, classId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/Hostel/students?classId=${classId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  getStudentsAssignedToHouse: (token, classId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/Hostel/students-assigned-to-House?classId=${classId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  allocateHouseToStudents: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/Hostel/allocate-house-to-students`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  unallocateHouseFromStudents: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/Hostel/un-allocate-house-to-students`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  createHostelFloor: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Hostel/CreateHostelfloor`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  editHostelFloor: (token, data) =>
    axiosClient
      .put(
        `${endpoint_two}/api/v${api_version}/Hostel/UpdateHostelfloor`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteFloor: (token, floorId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/Hostel/DeleteHostelfloor?floorId=${floorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  createHostelRoom: (token, data) =>
    axiosClient
      .post(
        `${endpoint_two}/api/v${api_version}/Hostel/CreateHostelroom`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  editHostelRoom: (token, data) =>
    axiosClient
      .put(
        `${endpoint_two}/api/v${api_version}/Hostel/UpdateHostelRoom`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteRoom: (token, roomId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/Hostel/DeleteHostelRoom?roomId=${roomId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  addBedSpace: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/Hostel/AddbedSpace`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  editBedSpace: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/Hostel/Update-BedSpace`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  deleteBedSpace: (token, bedId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/Hostel/DeleteBedSpace?bedId=${bedId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),
};
